declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}

// Log page views
export const pageview = (url: string) => {
  window.gtag('config', process.env.GA_TRACKING_ID, {
    page_path: url,
  })
}

// Log events
export const event = ({
  action,
  params,
}: {
  action: string
  params: object
}) => {
  window.gtag('event', action, params)
}
